/*
 * On-device share (canon draft section 11 / 11b; REFERRAL-BUILD-SPLIT-V1 §3
 * item 2). The Web Share API hands the card straight to the app the buyer
 * picks; nothing goes to Trumin.
 *
 *   files supported  → navigator.share({ files:[card], text: message + " " + url })
 *   files unsupported / no card → navigator.share({ text: message, url })
 *   no navigator.share          → 'unsupported' (caller shows the WhatsApp /
 *                                 Facebook / X links + Copy link)
 * A cancelled share sheet (AbortError) is NOT an error: 'aborted', silent.
 */
export type ShareOutcome = 'shared' | 'aborted' | 'unsupported' | 'failed'

export interface ShareNavigator {
  share?: (data: ShareData) => Promise<void>
  canShare?: (data: ShareData) => boolean
}

export async function shareReferral(
  nav: ShareNavigator,
  input: { file: File | null; message: string; url: string },
): Promise<ShareOutcome> {
  if (typeof nav.share !== 'function') return 'unsupported'
  const message = input.message.trim()
  let data: ShareData
  let filesOk = false
  try {
    filesOk = !!input.file && typeof nav.canShare === 'function' && nav.canShare({ files: [input.file] })
  } catch {
    filesOk = false
  }
  if (filesOk && input.file) data = { files: [input.file], text: message ? `${message} ${input.url}` : input.url }
  else data = message ? { text: message, url: input.url } : { url: input.url }
  try {
    await nav.share(data)
    return 'shared'
  } catch (e) {
    return e && typeof e === 'object' && (e as { name?: unknown }).name === 'AbortError' ? 'aborted' : 'failed'
  }
}
